<div class="margin-top-15">
    <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header>
            <mat-panel-title class="bold">
                {{ 'common.labels.filters' | transloco }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="_filterForm" class="padding">
            <div class="flex-container">
                <mat-form-field class="form-field">
                    <mat-label>{{ 'queueMonitorsFilter.queueName' | transloco }}</mat-label>
                    <input matInput formControlName="automationName" [placeholder]="'queueMonitorsFilter.automationName' | transloco" />
                </mat-form-field>
                <mat-checkbox formControlName="isFailed" class="form-field">
                    {{ 'queueMonitorsFilter.failed' | transloco }}
                </mat-checkbox>
                <mat-checkbox formControlName="isEnabled" class="form-field">
                    {{ 'queueMonitorsFilter.enabled' | transloco }}
                </mat-checkbox>
            </div>

            <div>
                <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
                    (click)="onClear()" [disabled]="!_filterForm.dirty">
                    {{ 'common.labels.clearFilters' | transloco }}
                </button>
                <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
                    (click)="onFilter()">
                    {{ 'common.labels.filter' | transloco }}
                </button>
            </div>
        </form>
    </mat-expansion-panel>
</div>